<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body pb-4">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="mt-0 font-bold"
          v-text="'Remove Discussion'"
        />
      </header>
      <p class="mb-0">
        Are you sure you want to remove <strong>{{ postTitle }}</strong>?
      </p>
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        class="btn"
        @click="archive"
        v-text="'Remove'"
      />
      <button
        type="button"
        class="ml-6"
        @click="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import { mapState } from 'vuex'

export default {
  name: 'ArchiveDiscussionPostModal',
  computed: {
    ...mapState({
      show: state => state.discussion.modals.archivePost.open,
      post: state => state.discussion.modals.archivePost.post,
    }),
    postTitle() {
      return this.post ? this.post.attributes.title : ''
    },
  },
  methods: {
    archive() {
      this.$emit('archivePost')

      this.close()
    },
    close() {
      this.$store.commit('discussionArchivePostModalClose')
    },
  },
}
</script>
